import { CreatelyApiClient } from '../../../lib/creately/CreatelyApiClient';
import { Logger } from '../../../utils/logger';

export interface OnboardingStatusData {
  intendedUsage?: string;
  industry?: string;
  jobTitle?: string;
  purpose?: string;
  organizationSize?: string;
  onboardingProgress?: string;
  onboardingLastUpdated?: string;
}

export class OnboardingStatusService {
  constructor(private apiClient: CreatelyApiClient) {}

  async updateOnboardingStatus(
    data: OnboardingStatusData,
    token: string
  ): Promise<{ date: string }> {
    try {
      const status = Object.entries(data)
        .filter(([, value]) => value !== undefined)
        .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
        .join(',');

      const query = `mutation {
        userUpdateOnboardingInfo(
          onboardingStatus: { ${status} }
        ) { date }
      }`;

      const result = await this.apiClient.graphql<{
        userUpdateOnboardingInfo: { date: string };
      }>({ query }, token);

      return result.userUpdateOnboardingInfo;
    } catch (error) {
      Logger.error('OnboardingStatusService', 'Failed to update onboarding status', error);
      throw error;
    }
  }

  async fetchOnboardingStatus(token: string): Promise<{
    onboardingProgress?: string;
    onboardingLastUpdated?: string;
  } | null> {
    try {
      const query = `{
        user {
          onboardingProgress
          onboardingLastUpdated
        }
      }`;

      const result = await this.apiClient.graphql<{
        user: {
          onboardingProgress?: string;
          onboardingLastUpdated?: string;
        };
      }>({ query }, token);

      return result.user;
    } catch (error) {
      Logger.error('OnboardingStatusService', 'Failed to fetch onboarding status', error);
      throw error;
    }
  }
}
